import { POST } from "../../APiHelper/API";

var searchPlayerController = null;

// team_id scopes the returned short names to the team the player would be
// added to. Short names are team specific, so an unscoped one blocks the add.
export const searchPlayer = (term, team_id, onSuccess, onError) => {
  const data = {
    term: term,
    team_id: team_id,
  };
  searchPlayerController = POST(
    `/api/v1/leagues/player/search`,
    data,
    onSuccess,
    onError,
    false,
    searchPlayerController
  );
};
